import { AfterContentInit, Component, ContentChildren, Input, OnDestroy, QueryList } from '@angular/core';
import { Subscription } from 'rxjs';
import { HamAccordionItemComponent } from '../accordion-item/accordion-item.component';

@Component({
    selector: 'ham-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
})
export class HamAccordionComponent implements AfterContentInit, OnDestroy {
    @ContentChildren(HamAccordionItemComponent) items!: QueryList<HamAccordionItemComponent>;

    @Input() multi = false; // Allow multiple items to be open simultaneously

    private subscriptions: Subscription[] = [];

    ngAfterContentInit() {
        this.setUpItems();

        this.items.changes.subscribe(() => {
            this.setUpItems();
        });
    }

    setUpItems() {
        // Unsubscribe from previous subscriptions to avoid memory leaks
        this.subscriptions.forEach((sub) => sub.unsubscribe());
        this.subscriptions = [];

        this.items.forEach((item) => {
            const sub = item.toggle.subscribe(() => {
                if (!this.multi) {
                    this.closeOthers(item);
                }
                item.expanded = !item.expanded;
            });
            this.subscriptions.push(sub);
        });
    }

    closeOthers(openItem: HamAccordionItemComponent) {
        this.items.forEach((item) => {
            if (item !== openItem) {
                item.expanded = false;
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
